import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-memoryCardDetails',
  templateUrl: './memoryCardDetails.component.html',
  styleUrls: ['./memoryCardDetails.component.scss'] 
})

export class MemoryCardDetailsComponent implements OnInit {

  memoryCardName:string = '';
  description:string = ''; 

  constructor(private dialogRef: MatDialogRef<MemoryCardDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {     
  
  }  
  
  ngOnInit(): void {
    this.memoryCardName= this.data.memoryCardName;
    this.description= this.data.memoryDescription;
  }     

  close() {    
    this.dialogRef.close(false);
  }   
  
}
